<div [innerHTML]="template?.content  || '' | safeHtml"></div>